__turbopack_context__.v({
  "absoluteCentered": "video-module-scss-module__iU4mqW__absoluteCentered",
  "badgeTiming": "video-module-scss-module__iU4mqW__badgeTiming",
  "buttonWrapper": "video-module-scss-module__iU4mqW__buttonWrapper",
  "captionButton": "video-module-scss-module__iU4mqW__captionButton",
  "ccButtonContainer": "video-module-scss-module__iU4mqW__ccButtonContainer",
  "controllerContainer": "video-module-scss-module__iU4mqW__controllerContainer",
  "currentTime": "video-module-scss-module__iU4mqW__currentTime",
  "desktopViewButton": "video-module-scss-module__iU4mqW__desktopViewButton",
  "innerRightContainer": "video-module-scss-module__iU4mqW__innerRightContainer",
  "modalVideoContainer": "video-module-scss-module__iU4mqW__modalVideoContainer",
  "playIcon": "video-module-scss-module__iU4mqW__playIcon",
  "playPauseButton": "video-module-scss-module__iU4mqW__playPauseButton",
  "playPauseContainer": "video-module-scss-module__iU4mqW__playPauseContainer",
  "remainingTime": "video-module-scss-module__iU4mqW__remainingTime",
  "rightContainer": "video-module-scss-module__iU4mqW__rightContainer",
  "timeDisplay": "video-module-scss-module__iU4mqW__timeDisplay",
  "timeProgressBar": "video-module-scss-module__iU4mqW__timeProgressBar",
  "videoContainer": "video-module-scss-module__iU4mqW__videoContainer",
  "videoContent": "video-module-scss-module__iU4mqW__videoContent",
  "videoControlsContainer": "video-module-scss-module__iU4mqW__videoControlsContainer",
  "videoTiming": "video-module-scss-module__iU4mqW__videoTiming",
  "videoTitle": "video-module-scss-module__iU4mqW__videoTitle",
  "videoTitleContainer": "video-module-scss-module__iU4mqW__videoTitleContainer",
  "volumeButton": "video-module-scss-module__iU4mqW__volumeButton",
  "volumeContainer": "video-module-scss-module__iU4mqW__volumeContainer",
  "volumeControl": "video-module-scss-module__iU4mqW__volumeControl",
  "youtubeVideo": "video-module-scss-module__iU4mqW__youtubeVideo",
});
